export default class BeEndpoints {
  //general
  static BASE_BE_URL = process.env.PREACT_APP_DJ_BASE_PATH;

  //accounts
  static LOGIN = "account/venue/login";
  static LOGOUT = "account/host/logout";
  static PROFILE_DETAILS = "account/venue";
  static GUEST_CHECKIN = "account/guest/checkin";
  static GUEST_LIST = "account/guest/list";
  static GUEST_BOOKING = "account/guest/booking";
  static GET_OTP = "account/user/otp";
  static VERIFY_OTP = "account/user/otp";
  static SIGN_UP = "account/user/signup";

  //spotify code
  static SPOTIFY_CODE = "account/spotify/code";

  // tracks
  static SONG_REQUESTS = "tracks/request/all";

  static GET_TRACKS = "/tracks/track/all";
  static SONG_REQUESTS = "/tracks/request/all";
  static UPDATE_SONG_STATUS = "/tracks/track/host/status";
  static TRACK_ACTION = "/tracks/host/request";

  //analytics
  static Analyitcs = "account/venue/analytics";

  //Playlists

  static ADD_PLAYLIST_TAG = "/playlists/playlist/slotmap";
  static FETCH_ALL_PLAYLISTS = "/playlists/playlist/options";

  static PLAYLIST_DETAILS = "/playlists/playlist/details";
  static ADD_PLAYLIST_SONG = "/playlists/playlist/track/add";

  //slots
  static GET_ALL_SLOTS = "/slots/slot/all";
  static SLOT_UPDATE = "/slots/slot";

  // food and beverage category
  static FOOD_BEVERAGE = "offers/food-beverage";

  // Price data
  static PRICE_DATA = "/offers/pricing";

  // Offer tamplates
  static OFFER_TAMPLATES = "/offers/template";

  //
  static OFFER_DATA = "/offers/offer";

  // listed offer
  static LISTED_OFFER = "/offers/all";

  // claimed unclaimed offers

  static CLAIMED_OFFER = "/offers";

  //
  static EVENT_OFFER = "/offers/event";
  // must try
  static MUST_TRY = "/offers/must-try";

  // WhatsApp stats
  static WHATSAPP_STATS = "/whatsapp/stats";
  static WHATSAPP_FILTER = "/whatsapp/filter";
  static WHATSAPP_TEMPLATE = "/whatsapp/template";
  static WHATSAPP_PROMOTION = "/whatsapp/promotion";
  static WHATSAPP_DASHBOARD = "/whatsapp/dashboard";
  static WHATSAPP_SCHEDULE = "/whatsapp/schedule";
  static WHATSAPP_WALLET_INFO = "/whatsapp/wallet/info";
  static WHATSAPP_SUBSCRIPTION = "/whatsapp/subscription";
  static WHATSAPP_PAYMENT = "/payments/payment";
  static WHATSAPP_PACKAGES = "/whatsapp/packages";
  static WHATSAPP_LOCATIONS = "/whatsapp/locations";
  static GET_PACK_INFO = "/whatsapp/get-pack-info";
  static APPLY_COUPON = "/whatsapp/apply-coupon";
  static CONFIRM_PACK = "/whatsapp/confirm-pack";
}
